const pageComponents = {
  Home: import("./Home"),
  Login: import("./Login"),
  Register: import("./Register"),
  PasswordResetRequest: import("./PasswordResetRequest"),
  PasswordReset: import("./PasswordReset"),
  Shop: import("./Shop"),
  Brand: import("./Shop"),
  Category: import("./Shop"),
  Cart: import("./Cart"),
  Checkout: import("./Checkout"),
  Product: import("./Product"),
  PaymentStatus: import("./PaymentStatus"),
  OrderPayment: import("./OrderPayment"),
  Wishlist: import("./Wishlist"),
  EmailVerification: import("./EmailVerification"),
  ProductCompare: import("./ProductCompare"),
  OrderTracking: import("./OrderTracking"),
  PrivacyPolicy: import("./PrivacyPolicy"),
  AboutUs: import("./About"),
  ContactUs: import("./Contact"),
  Search: import("./Shop"),
  OrderListing: import("./OrderListing"),
  OrderDetails: import("./OrderDetails"),
};

export default pageComponents;
